<div class="team-list-container" (click)="closeActionMenu()">
  <div class="page-header">
    <h2>Team</h2>
    <button class="btn btn-primary" (click)="showAddUserForm()" *ngIf="!showAddForm">
      Add User
    </button>
  </div>

  <!-- Reset Password Notification (Top Right) -->
  <div *ngIf="resetPasswordNotification" [ngClass]="resetPasswordNotificationType === 'success' ? 'success-notification' : 'error-notification'">
    <svg *ngIf="resetPasswordNotificationType === 'success'" class="success-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#10b981"/>
      <path d="M8 12L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg *ngIf="resetPasswordNotificationType === 'error'" class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#dc2626"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span [ngClass]="resetPasswordNotificationType === 'success' ? 'success-notification-message' : 'error-notification-message'">{{ resetPasswordNotification }}</span>
  </div>

  <!-- Edit User Notification (Top Right) -->
  <div *ngIf="editUserNotification" [ngClass]="editUserNotificationType === 'success' ? 'success-notification' : 'error-notification'">
    <svg *ngIf="editUserNotificationType === 'success'" class="success-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#10b981"/>
      <path d="M8 12L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg *ngIf="editUserNotificationType === 'error'" class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#dc2626"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span [ngClass]="editUserNotificationType === 'success' ? 'success-notification-message' : 'error-notification-message'">{{ editUserNotification }}</span>
  </div>

  <!-- Success Notification (Top Right) -->
  <div *ngIf="successMessage" class="success-notification">
    <svg class="success-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#10b981"/>
      <path d="M8 12L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="success-notification-message">{{ successMessage }}</span>
  </div>

  <!-- Error Notification (Top Right) -->
  <div *ngIf="errorMessage" class="error-notification">
    <svg class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#dc2626"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="error-notification-message">{{ errorMessage }}</span>
  </div>

  <!-- Search and Filters -->
  <div class="filters-bar">
    <div class="search-box">
      <input type="text" class="search-input" placeholder="Search by Name, Email, or Manager ID" [(ngModel)]="searchTerm" (input)="onSearch()">
      <span class="search-icon">🔍</span>
    </div>
    <select class="filter-select" [(ngModel)]="selectedCountry" (change)="applyFilters()">
      <option value="">Country</option>
      <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
    </select>
    <select class="filter-select" [(ngModel)]="selectedStatus" (change)="applyFilters()">
      <option value="">Filter by Status</option>
      <option value="Active">Active</option>
      <option value="Inactive">Inactive</option>
    </select>
    <button type="button" class="btn btn-reset" (click)="resetFilters()">Reset</button>
  </div>

  <!-- Add User Modal -->
  <div class="modal-overlay" *ngIf="showAddForm">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Add User</h3>
        <button type="button" class="modal-close" (click)="cancelForm()">&times;</button>
      </div>
      <form (ngSubmit)="createUser()">
        <div class="form-row">
          <div class="form-group">
            <label>First Name<span class="required-asterisk">*</span></label>
            <input type="text" class="form-control" [class.error]="firstNameError" [(ngModel)]="userForm.firstName" name="firstName" placeholder="Enter First Name" required (input)="firstNameError = ''">
            <div *ngIf="firstNameError" class="field-error">{{ firstNameError }}</div>
          </div>
          <div class="form-group">
            <label>Last Name</label>
            <input type="text" class="form-control" [(ngModel)]="userForm.lastName" name="lastName" placeholder="Enter Last Name">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label>Email ID<span class="required-asterisk">*</span></label>
            <input type="email" class="form-control" [class.error]="emailError" [(ngModel)]="userForm.email" name="email" placeholder="Enter Email ID" required (input)="emailError = ''">
            <div *ngIf="emailError" class="field-error">{{ emailError }}</div>
          </div>
          <div class="form-group">
            <label>Password<span class="required-asterisk">*</span></label>
            <div class="password-input-wrapper">
              <input [type]="showPassword ? 'text' : 'password'" class="form-control" [class.error]="passwordErrorAdd" [(ngModel)]="userForm.password" name="password" placeholder="Enter Password" required minlength="6" (input)="passwordErrorAdd = ''">
              <button type="button" class="password-toggle" (click)="togglePasswordVisibility()">
                <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 3C5 3 1.73 7.11 1 10C1.73 12.89 5 17 10 17C15 17 18.27 12.89 19 10C18.27 7.11 15 3 10 3Z" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="10" cy="10" r="3" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 3C5 3 1.73 7.11 1 10C1.73 12.89 5 17 10 17C15 17 18.27 12.89 19 10C18.27 7.11 15 3 10 3Z" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M3 3L17 17" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            <div *ngIf="passwordErrorAdd" class="field-error">{{ passwordErrorAdd }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label>Phone No<span class="required-asterisk">*</span></label>
            <div class="phone-input-group">
              <select class="form-control phone-code" [(ngModel)]="userForm.phoneCountryCode" name="phoneCountryCode">
                <option *ngFor="let code of countryCodes" [value]="code.code">{{ code.label }}</option>
              </select>
              <input type="text" class="form-control phone-number" [class.error]="phoneError" [(ngModel)]="userForm.phone" name="phone" placeholder="Enter Phone No" required (input)="phoneError = ''">
            </div>
            <div *ngIf="phoneError" class="field-error">{{ phoneError }}</div>
          </div>
          <div class="form-group">
            <label>Role</label>
            <select class="form-control" [(ngModel)]="userForm.role" name="role">
              <option *ngFor="let role of roles" [value]="role.value">{{ role.label }}</option>
            </select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label>Country</label>
            <select class="form-control" [(ngModel)]="userForm.country" name="country">
              <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
            </select>
          </div>
        </div>
        <!-- Error message inside modal -->
        <div *ngIf="addUserError" class="alert alert-danger" style="margin: 16px 0 0 0;">
          {{ addUserError }}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-cancel" (click)="cancelForm()">Cancel</button>
          <button type="submit" class="btn btn-submit" [disabled]="formLoading">
            {{ formLoading ? 'Submitting...' : 'Submit' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Edit Team Member Modal -->
  <div class="modal-overlay" *ngIf="showEditModal">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Edit User</h3>
        <button type="button" class="modal-close" (click)="closeEditModal()">&times;</button>
      </div>
      <form (ngSubmit)="updateMember()">
        <div class="form-row">
          <div class="form-group">
            <label>First Name<span class="required-asterisk">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="editForm.firstName" name="editFirstName" placeholder="Enter First Name" required>
          </div>
          <div class="form-group">
            <label>Last Name</label>
            <input type="text" class="form-control" [(ngModel)]="editForm.lastName" name="editLastName" placeholder="Enter Last Name">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label>Email ID<span class="required-asterisk">*</span></label>
            <input type="email" class="form-control" [(ngModel)]="editForm.email" name="editEmail" placeholder="Enter Email ID" required>
          </div>
          <div class="form-group">
            <label>Phone No<span class="required-asterisk">*</span></label>
            <div class="phone-input-group">
              <select class="form-control phone-code" [(ngModel)]="editForm.phoneCountryCode" name="editPhoneCountryCode">
                <option *ngFor="let code of countryCodes" [value]="code.code">{{ code.label }}</option>
              </select>
              <input type="text" class="form-control phone-number" [(ngModel)]="editForm.phone" name="editPhone" placeholder="Enter Phone No" required>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label>Role</label>
            <input type="text" class="form-control" [(ngModel)]="editForm.role" name="editRole" value="Procurement Manager" readonly>
          </div>
          <div class="form-group">
            <label>Country</label>
            <select class="form-control" [(ngModel)]="editForm.country" name="editCountry">
              <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-cancel" (click)="closeEditModal()">Cancel</button>
          <button type="submit" class="btn btn-submit" [disabled]="formLoading">
            {{ formLoading ? 'Updating...' : 'Update' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Success Modal -->
  <div class="modal-overlay success-modal-overlay" *ngIf="showSuccessModal" (click)="closeSuccessModal()">
    <div class="success-modal-content" (click)="$event.stopPropagation()">
      <button type="button" class="success-modal-close" (click)="closeSuccessModal()">&times;</button>
      <div class="success-modal-icon">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="32" fill="#1e3a8a"/>
          <path d="M20 32L28 40L44 24" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="success-modal-message">{{ successModalMessage }}</div>
    </div>
  </div>

  <!-- Reset Password Modal -->
  <div class="modal-overlay" *ngIf="showResetPasswordModalFlag" (click)="closeResetPasswordModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Reset Password</h3>
        <button type="button" class="modal-close" (click)="closeResetPasswordModal()">&times;</button>
      </div>
      <form (ngSubmit)="resetPassword()">
        <div class="form-row">
          <div class="form-group">
            <label>Password<span class="required-asterisk">*</span></label>
            <input type="password" class="form-control" [class.error]="passwordError" [(ngModel)]="resetPasswordForm.password" name="resetPassword" placeholder="Enter Password" required minlength="6" (input)="onPasswordInput()">
            <div *ngIf="passwordError" class="field-error">{{ passwordError }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-cancel" (click)="closeResetPasswordModal()">Cancel</button>
          <button type="submit" class="btn btn-submit" [disabled]="formLoading">
            {{ formLoading ? 'Resetting...' : 'Reset' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Team Members Table -->
  <div class="table-container" *ngIf="!loading && filteredTeamMembers.length > 0">
    <table class="team-table">
      <thead>
        <tr>
          <th>Manager ID</th>
          <th>Name</th>
          <th>Role</th>
          <th>Country</th>
          <th>Created on</th>
          <th>Status</th>
          <th>Last Updated on</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let member of filteredTeamMembers">
          <td>{{ member.managerId || member.userId || '--' }}</td>
          <td>{{ member.name || '--' }}</td>
          <td>{{ member.role || 'Procurement Manager' }}</td>
          <td>{{ member.country || '--' }}</td>
          <td>{{ formatDate(member.createdAt) }}</td>
          <td>
            <span class="status-badge" [ngClass]="member.isActive ? 'status-active' : 'status-inactive'">
              {{ member.isActive ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td>{{ formatDate(member.updatedAt) }}</td>
          <td>
            <div class="actions-cell">
              <div class="action-menu" (click)="toggleActionMenu(member.userId, $event); $event.stopPropagation()">
                <span class="dots-icon" title="More actions">⋮</span>
                <div class="action-dropdown" *ngIf="showActionMenu[member.userId]" (click)="$event.stopPropagation()">
                  <a href="#" class="dropdown-item" (click)="editMember(member); $event.preventDefault(); $event.stopPropagation()">
                    Edit
                  </a>
                  <a href="#" class="dropdown-item" (click)="showResetPasswordModal(member); $event.preventDefault(); $event.stopPropagation()">
                    Reset Password
                  </a>
                  <a href="#" class="dropdown-item deactivate" *ngIf="member.isActive" (click)="deactivateMember(member); $event.preventDefault(); $event.stopPropagation()">
                    Deactivate
                  </a>
                  <a href="#" class="dropdown-item activate" *ngIf="!member.isActive" (click)="activateMember(member); $event.preventDefault(); $event.stopPropagation()">
                    Activate
                  </a>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    
    <!-- End of Data Message -->
    <div class="end-of-data" *ngIf="!hasMoreData && !loading && filteredTeamMembers.length > 0">
      <p>No more users to load</p>
    </div>
  </div>

  <div class="empty-state" *ngIf="!loading && filteredTeamMembers.length === 0">
    <p>No team members found</p>
  </div>

  <div class="loading-state" *ngIf="loading">
    <p>Loading team members...</p>
  </div>
</div>

